import { render } from "./cardIndex.vue?vue&type=template&id=562c7902&scoped=true"
import script from "./cardIndex.vue?vue&type=script&lang=js"
export * from "./cardIndex.vue?vue&type=script&lang=js"

import "./cardIndex.vue?vue&type=style&index=0&id=562c7902&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c7902"]])

export default __exports__